import "../../components/ErrorScreen.css";
import logo from "../../assets/EPTICONO.svg";

import { motion } from "framer-motion";
import { containerVariants } from "../../animations/transitions";

import { useTranslation } from "react-i18next";

const ErrorScreen = () => {
  const [t, i18n] = useTranslation("global");

  return (
    <div className="errorscreen__container">
      <motion.div
        className="errorscreen__modal"
        variants={containerVariants}
        initial="hidden"
        animate="visible"
      >
        <div className="errorscreen__imagecontainer">
          <img src={logo} alt="" />
        </div>
        <h2 className="errorscreen__problema">{t("ERRORSCREEN.problema")}</h2>
        <p className="errorscreen__minutos">{t("ERRORSCREEN.minutos")}</p>
        <p
          className="errorscreen__reportar"
          onClick={() => {
            document.location =
              "mailto:info@escolaportbarcelona.com?subject=&body=";
          }}
        >
          info@escolaportbarcelona.com
        </p>
      </motion.div>
    </div>
  );
};

export default ErrorScreen;
